import { useRef, useEffect, useState } from "react";
import Select from 'react-select';
import { ddStyles } from "../utils/CommonStyles.js";

let commodityOptions = [];
let productOptions = [];
function UserProductTableRow({ key, companyId, commodityList, products, handleSubmit, setError, t, setAdd, oddIdx }) {
	const [commodityLoaded, setCommodityLoaded] = useState(false);
	const [commoditySelected, setCommoditySelected] = useState({ name: "commodityKey", label: "", value: 0 });
	const [productLoaded, setProductLoaded] = useState(false);
	const [productSelected, setProductSelected] = useState({ name: "companyProductKey", label: "", value: 0 });
	const [isSubmit, setIsSubmit] = useState(false);

	useEffect(() => {
		if (!companyId || companyId == 0) {
			setCommodityValues(commodityList);
		} else {
			setCompanyProductValues(products);
		}

	}, []);

	function setCommodityValues(commodityObj) {
		let commodityValue = {};
		commodityOptions = [];
		commodityOptions.push({ label: "", value: 0 });
		if (commodityObj && commodityObj.length > 0) {
			commodityObj.map((aCommodity, index) => {
				commodityValue.label = aCommodity.commodityName;
				commodityValue.value = aCommodity.commodityKey;
				commodityOptions.push(commodityValue);
				commodityValue = {};
			});
			
		}
		setCommoditySelected({ ...commoditySelected, label: "", value: 0 });
		setCommodityLoaded(true);
	}

	function setCompanyProductValues(productObj) {
		let productValue = {};
		productOptions = [];
		productOptions.push({ label: "", value: 0 });
		if (productObj && productObj.length > 0) {
			productObj.map((aProduct, index) => {
				productValue.label = aProduct.commodityName + ", " + aProduct.productName + (aProduct.productSku ? (", " + aProduct.productSku) : "");
				productValue.value = aProduct.companyProductKey;
				productOptions.push(productValue);
				productValue = {};
			});
			
		}
		setProductSelected({ ...productSelected, label: "", value: 0 });
		setProductLoaded(true);
	}

	const commodityHandler = (selectedOption, action) => {
		let commodityKey = selectedOption ? selectedOption.value : 0;
		let commodityName = selectedOption ? selectedOption.label : "";
		commoditySelected.value = commodityKey;
		setCommoditySelected({ ...commoditySelected, label: (commodityName), value: commodityKey });
	}

	const productHandler = (selectedOption, action) => {
		let companyProductKey = selectedOption ? selectedOption.value : 0;
		let productName = selectedOption ? selectedOption.label : "";
		productSelected.value = companyProductKey;
		setProductSelected({ ...productSelected, label: (productName), value: companyProductKey });
	}
	function submitComplete() {
		setIsSubmit(false);
	}
	function submitRow() {
		setError("");
		setIsSubmit(true);
		let initialValues = {commodityKey:0, companyProductKey:0};
		if (!companyId || companyId == 0) {
			initialValues.commodityKey = commoditySelected.value;
		} else {
			const selectedProduct = products.find(aProduct => aProduct.companyProductKey === productSelected.value);
			if (selectedProduct) {
				initialValues.commodityKey = selectedProduct.commodityKey;
				initialValues.companyProductKey = selectedProduct.companyProductKey;
			}
		}

		if (!initialValues.commodityKey || initialValues.commodityKey === 0) {
			setError(t("error.commoName.Reqd"));
			setIsSubmit(false);
		} else {
			handleSubmit(1, initialValues, submitComplete);
		}

	}
	function submitCancel() {
		setError("");
		setAdd(false);
	}
	return (
		<tr key={key}>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}></td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				{(commodityLoaded && (!companyId || companyId == 0)) ? <Select
					name="commodityKey"
					options={commodityOptions}
					onChange={commodityHandler}
					placeholder={""}
					value={commoditySelected}
					isSearchable={true}
					isClearable={true}
					className="myselect"
					inputId="commodityKey-input"
					styles={ddStyles}
				/> : <></>
				}
				{(productLoaded && (companyId && companyId > 0)) ? <Select
					name="companyProductKey"
					options={productOptions}
					onChange={productHandler}
					placeholder={""}
					value={productSelected}
					isSearchable={true}
					isClearable={true}
					className="myselect"
					inputId="companyProductKey-input"
					styles={ddStyles}
				/> : <></>
				}
			</td>

			<td className={oddIdx ? "list-td col odd" : "list-td col even"}></td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}></td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}></td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{t("page.active")}</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				<div id="submit-spinner"
					className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
				>
				</div>
				{((commodityOptions && commodityOptions.length > 0) || (productOptions && productOptions.length > 0)) ?
					(<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitRow())}>{t("page.submit")}</button>)
					:
					(<></>)
				}
				<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitCancel())}>{t("page.cancel")}</button></td>
		</tr>
	)

}
export default UserProductTableRow;